import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('media-templates-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider.state('cms-mediaTemplates', {
      parent: 'arw',
      url: '/cms-media-templates/',
      template: `<cms-media-templates></cms-media-templates>`,
      redirectTo: 'permissions-denied',
      params: {
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Media Templates')));
          },
        ],
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/media-templates/media-templates-routing-module.js